import { Injectable } from '@angular/core';
import { applyDocumentThemeColors } from '../utils/theme-colors.util';

@Injectable({ providedIn: 'root' })
export class AppThemeService {
  applyThemeColors(colors: unknown): void {
    applyDocumentThemeColors(colors);
  }
}
